"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValidToken = getValidToken;
exports["default"] = getTokenHeader;

var _negate2 = _interopRequireDefault(require("lodash/negate"));

var _typeofOrNull = _interopRequireDefault(require("../misc/typeofOrNull"));

var _jwtHelper = require("./jwtHelper");

var _refreshTokens = _interopRequireDefault(require("./refreshTokens"));

var _manageTokens = require("./manageTokens");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var functionName = 'getValidToken';
var notExpired = (0, _negate2["default"])(_jwtHelper.isTokenExpired);

function getValidToken(client) {
  var tokenType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'idToken';
  var tokenValidator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : notExpired;
  var tokenRefresher = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _refreshTokens["default"];
  var getState = client.getState;

  if (typeof getState !== 'function') {
    var message = "\n      ".concat(functionName, " expected the client argument to contain a\n      getState property of type function. Instead it received a something of\n      type ").concat((0, _typeofOrNull["default"])(getState), ".\n    ");
    return Promise.reject(new Error(message));
  }

  var token = (0, _manageTokens.getToken)(client, tokenType);

  if (typeof token !== 'string') {
    var _message = "\n      ".concat(functionName, " expected an id token to be a string.\n      Instead it found something of type\n      ").concat((0, _typeofOrNull["default"])(token), ". Please make sure you only call this\n      method when your client has authenticated and has a valid id token.\n    ");

    return Promise.reject(new Error(_message));
  }

  if (tokenValidator(token, 60)) return Promise.resolve(token); // automatically renew tokens

  return tokenRefresher(client);
}

function getTokenHeader(client) {
  return getValidToken(client).then(function (token) {
    return {
      authorization: 'Bearer ' + token
    };
  });
}